export enum GenderEnum {
  Male = 1,
  Female = 2,
}
